import { render, staticRenderFns } from "./SoftAutocomplete.vue?vue&type=template&id=7640400e"
import script from "./SoftAutocomplete.vue?vue&type=script&lang=ts"
export * from "./SoftAutocomplete.vue?vue&type=script&lang=ts"
import style0 from "./autocomplete.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports